/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // Filter product thumbnails to show only images for the selected color variant
    // The logic: get all featured_media IDs from product variants (these are the "covers")
    // Find the current cover and show only thumbnails from that cover until the next cover
    var variant = event.detail.variant;
    var container = event.target;
    
    if (!variant || !variant.featured_media) {
      return;
    }
    
    var featuredMediaId = variant.featured_media.id.toString();
    
    // Find thumbs holder - search in the product section, not just the container
    var productSection = container.closest('[data-section-type="product"]') || container.closest('.product-section');
    if (!productSection) {
      return;
    }
    
    var thumbsHolder = productSection.querySelector('[data-thumbs-holder]');
    if (!thumbsHolder) {
      return;
    }
    
    var allThumbs = Array.from(thumbsHolder.querySelectorAll('[data-slideshow-thumbnail]'));
    if (allThumbs.length === 0) {
      return;
    }
    
    // Get product JSON - search in the form or product section
    var productJsonScript = container.querySelector('[data-product-json]') || 
                           productSection.querySelector('[data-product-json]') ||
                           document.querySelector('[data-product-json]');
    
    var coverMediaIds = [];
    
    if (productJsonScript && productJsonScript.textContent) {
      try {
        var productData = JSON.parse(productJsonScript.textContent);
        // Extract all featured_media IDs from variants (these are the "covers")
        if (productData.variants && Array.isArray(productData.variants)) {
          productData.variants.forEach(function(v) {
            if (v.featured_media && v.featured_media.id) {
              var mediaId = v.featured_media.id.toString();
              if (coverMediaIds.indexOf(mediaId) === -1) {
                coverMediaIds.push(mediaId);
              }
            }
          });
        }
      } catch (e) {
        console.warn('Could not parse product JSON:', e);
      }
    }
    
    // Find the index of the current cover thumbnail (the featured media of selected variant)
    var currentCoverIndex = -1;
    allThumbs.forEach(function(thumb, index) {
      var mediaId = thumb.getAttribute('data-media-select');
      if (mediaId === featuredMediaId) {
        currentCoverIndex = index;
      }
    });
    
    if (currentCoverIndex === -1) {
      // If we can't find the featured media, show all thumbs
      allThumbs.forEach(function(thumb) {
        thumb.style.display = '';
        thumb.classList.remove('hide');
      });
      return;
    }
    
    // Find all cover indices (thumbnails that are featured_media of some variant)
    var coverIndices = [];
    if (coverMediaIds.length > 0) {
      allThumbs.forEach(function(thumb, index) {
        var mediaId = thumb.getAttribute('data-media-select');
        if (coverMediaIds.indexOf(mediaId) !== -1) {
          coverIndices.push(index);
        }
      });
    }
    
    // Sort cover indices to ensure they're in order
    coverIndices.sort(function(a, b) { return a - b; });
    
    // Calculate the range: from current cover to next cover (exclusive)
    var startIndex = currentCoverIndex;
    var endIndex = allThumbs.length - 1;
    
    if (coverIndices.length > 0) {
      // Find the next cover index after the current one
      for (var i = 0; i < coverIndices.length; i++) {
        if (coverIndices[i] > currentCoverIndex) {
          endIndex = coverIndices[i] - 1;
          break;
        }
      }
      
      // Make sure we start from the cover of the current group
      // Find the cover that is <= currentCoverIndex (the start of current group)
      for (var i = coverIndices.length - 1; i >= 0; i--) {
        if (coverIndices[i] <= currentCoverIndex) {
          startIndex = coverIndices[i];
          break;
        }
      }
    }
    
    // Show only thumbnails in the range from current cover to next cover (inclusive)
    allThumbs.forEach(function(thumb, index) {
      if (index >= startIndex && index <= endIndex) {
        thumb.style.display = '';
        thumb.classList.remove('hide');
      } else {
        thumb.style.display = 'none';
        thumb.classList.add('hide');
      }
    });
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // Also filter thumbnails on page load if a variant is already selected
  function filterThumbnailsOnLoad() {
    var productSection = document.querySelector('[data-section-type="product"]');
    if (!productSection) {
      return;
    }
    
    var productForm = productSection.querySelector('[data-product-form]');
    if (!productForm) {
      return;
    }
    
    // Try to get the current variant from the form
    var variantIdInput = productForm.querySelector('input[name="id"]');
    if (!variantIdInput) {
      return;
    }
    
    var currentVariantId = variantIdInput.value;
    if (!currentVariantId) {
      return;
    }
    
    // Get product JSON to find the variant
    var productJsonScript = productSection.querySelector('[data-product-json]') || 
                           document.querySelector('[data-product-json]');
    
    if (!productJsonScript || !productJsonScript.textContent) {
      return;
    }
    
    try {
      var productData = JSON.parse(productJsonScript.textContent);
      if (productData.variants && Array.isArray(productData.variants)) {
        var currentVariant = productData.variants.find(function(v) {
          return v.id.toString() === currentVariantId.toString();
        });
        
        if (currentVariant && currentVariant.featured_media) {
          // Dispatch a variant change event to trigger the filter
          var event = new CustomEvent('theme:variant:change', {
            detail: { variant: currentVariant },
            bubbles: true
          });
          productForm.dispatchEvent(event);
        }
      }
    } catch (e) {
      console.warn('Could not parse product JSON on load:', e);
    }
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', filterThumbnailsOnLoad);
  } else {
    filterThumbnailsOnLoad();
  }

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
